import { render, staticRenderFns } from "./RectShape.vue?vue&type=template&id=71bd025a&scoped=true"
import script from "./RectShape.vue?vue&type=script&lang=js"
export * from "./RectShape.vue?vue&type=script&lang=js"
import style0 from "./RectShape.vue?vue&type=style&index=0&id=71bd025a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bd025a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71bd025a')) {
      api.createRecord('71bd025a', component.options)
    } else {
      api.reload('71bd025a', component.options)
    }
    module.hot.accept("./RectShape.vue?vue&type=template&id=71bd025a&scoped=true", function () {
      api.rerender('71bd025a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/canvas/customComponent/RectShape.vue"
export default component.exports